// src/pages/GiftCards.js
import React, { useEffect } from 'react';
import SeoHead from '../seo/SeoHead';
import GiftCardHero from '../main/GiftCardHero';
import GiftCardGenerator from '../main/GiftCardGenerator';

export default function ShopGiftCards() {
  // scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SeoHead
        title="Gift Cards – Marrakech Reserve"
        description="Give the gift of premium Marrakech Reserve olive oil. Our digital Gift Cards are redeemable for extra‑virgin, small‑batch olive oils, perfect for food lovers, gourmet chefs, and eco‑conscious friends."
        url="https://marrakech-reserve.com/shop-giftcard"
        keywords={
          "gift card, olive oil gift card, Marrakech Reserve gift card, premium olive oil gift, " +
          "extra virgin olive oil gift, gourmet gift card, artisanal olive oil, " +
          "sustainable gift, foodie gift, holiday gift, luxury culinary gift, organic olive oil gift, " +
          "small batch olive oil, Moroccan olive oil"
        }
      />
      <GiftCardHero />
      <GiftCardGenerator />
    </>
  );
}
